import React, {useEffect, useState} from "react"

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import {describeDateTime} from "../../helpers/utils"
import LoaderList from "../../components/Common/loaderList"
import {MDBDataTable} from "mdbreact"

const EstoqueFilialLista = props => {

    const [data, setData] = useState({
        columns: [
            { label: "Código", field: "Código", sort: "asc", width: 110 },
            { label: "Loja", field: "Loja", sort: "asc", width: 110 },
            { label: "Descrição", field: "Descrição", sort: "asc", width: 230 },
            { label: "Est. Atual", field: "Est. Atual", sort: "asc", width: 110 },
            { label: "Est. Mínimo", field: "Est. Mínimo", sort: "asc", width: 110 },
            { label: "Est. Máximo", field: "Est. Máximo", sort: "asc", width: 110 },
            { label: "Últ. Entrada", field: "Últ. Entrada", sort: "asc", width: 110 },
            { label: "Últ. Saída", field: "Últ. Saída", sort: "asc", width: 110 },
            { label: "Últ. Ajuste de preço", field: "Últ. Ajuste de preço", sort: "asc", width: 110 },
            { label: "Últ. Atualização", field: "Últ. Atualização", sort: "asc", width: 110 },
            { label: "Últ. Inventário", field: "Últ. Inventário", sort: "asc", width: 110 },
            { label: "Alteração do cadastro", field: "Alteração do cadastro", width: 110 },
            { label: "Usuário que alterou", field: "Usuário que alterou", sort: "asc", width: 110 },
        ],
        rows: []
    })

    useEffect(() => {
        if(Array.isArray(props.listaEstoqueFilial)) {
            const rows = props.listaEstoqueFilial?.map(item => ({
                "Código": item.id,
                Loja: item.loja,
                "Descrição": item.descricao,
                "Est. Atual": item.est_atual,
                "Est. Mínimo": item.est_minimo,
                "Est. Máximo": item.est_maximo,
                "Últ. Entrada": describeDateTime(item.ult_entrada),
                "Últ. Saída": describeDateTime(item.ult_saida),
                "Últ. Ajuste de preço": describeDateTime(item.ult_preco),
                "Últ. Atualização": describeDateTime(item.ult_atualizacao),
                "Últ. Inventário": describeDateTime(item.ult_balanco),
                "Alteração do cadastro": describeDateTime(item.altdata),
                "Usuário que alterou": `${item?.altfunc} - ${(item?.altfunc_Nome ? item.altfunc_Nome : 'N/A')}`,
            }))

            setData({
                columns: data.columns,
                rows: rows
            })
        }
    }, [props.listaEstoqueFilial])

    return <>
        { props.loading ? <LoaderList></LoaderList> :
            <>
                <div className="table-responsive">
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        data={ data }
                        entriesLabel={ "Mostrar Registros" }
                        infoLabel={ ["Exibindo", "a", "de", "registros"] }
                        noRecordsFoundLabel={ "Nenhum registro encontrado" }
                        paginationLabel={ ["Anterior", "Próximo"] }
                        searchLabel={ "Pesquisar" }
                        entries={5}
                        entriesOptions={[5,10,20,50,100]}
                    />
                </div>
            </>
        }
    </>
}

EstoqueFilialLista.propTypes = {
    listaEstoqueFilial: PropTypes.array,
    loading: PropTypes.bool,
    empresa: PropTypes.any
}

export default EstoqueFilialLista